import { AuthType, typedMemo } from "src/types";
import { Image } from "react-bootstrap";
import { LogoCie, LogoSelfID, LogoSpid, UserLogo } from "src/assets";
import { Button, StrongTranslationString } from "src/ui/widgets";
import { useTranslation } from "react-i18next";

import "./signature.scss";

export const SignatureStep = typedMemo(
  ({ onSubmit }: { onSubmit: (authType: AuthType) => void }) => {
    const { t } = useTranslation();

    const redirectSpidInfo = () => {
      window.open(
        "https://www.spid.gov.it/cos-e-spid/come-attivare-spid/",
        "_blank",
      );
    };

    const Title = (
      <div className="mb-2">
        <div className="title-xs--700 mb-2">
          {t("data_entry.signature_a_step.title")}
        </div>
        <div className="subtitle-xs--600">
          {t("data_entry.signature_a_step.subtitle")}
        </div>
      </div>
    );

    const Spid = (
      <div>
        <div className="d-flex flex-column align-items-center">
          <div className="my-3">
            <Image src={LogoSpid} height={38} />
          </div>
          <div>{t("data_entry.signature_a_step.spid")}</div>
          <div className="my-4">
            <Button
              classes="join-spid-cie-button py-2 px-2"
              text={t("data_entry.signature_a_step.join_with_spid")}
              classesIconLeft="me-3"
              iconLeft={UserLogo}
              iconSize={33}
              classesText="label-xl--500"
              onPress={() => onSubmit(AuthType.SPID)}
            />
          </div>
        </div>
        <div>
          <StrongTranslationString
            i18nKey="data_entry.signature_a_step.not_have_spid"
            color="var(--hyper-link-color)"
            onClick={redirectSpidInfo}
          />
        </div>
      </div>
    );

    const Cie = (
      <div className="mt-3 d-flex flex-column align-items-center">
        <div className="my-3">
          <Image src={LogoCie} height={65} />
        </div>
        <div>{t("data_entry.signature_a_step.cie")}</div>
        <div className="my-4">
          <Button
            classes="join-spid-cie-button py-2 px-2"
            text={t("data_entry.signature_a_step.join_with_cie")}
            classesIconLeft="filter-white me-3"
            iconLeft={LogoCie}
            iconSize={35}
            classesText="label-xl--500"
            onPress={() => onSubmit(AuthType.CIE)}
          />
        </div>
      </div>
    );

    const SelfID = (
      <div className="mt-3 d-flex flex-column align-items-center">
        <div className="align-self-start">
          {t("data_entry.signature_a_step.selfid")}
        </div>
        <div className="my-4">
          <Button
            classes="join-spid-cie-button py-2 px-2"
            text={t("data_entry.signature_a_step.join_with_selfid")}
            subtext={t("data_entry.signature_a_step.join_with_selfid_subtext")}
            classesIconLeft="me-3"
            iconLeft={LogoSelfID}
            iconSize={35}
            classesText="label-xl--500 d-flex flex-column align-items-start justify-content-center"
            classesSubtext="label-s d-block lh-1"
            onPress={() => onSubmit(AuthType.SELFID)}
          />
        </div>
      </div>
    );

    const Body = (
      <div className="d-flex flex-column align-items-center">
        <div className="mt-4 mb-2 title-xxl--700">Login</div>
        <div style={{ maxWidth: 900 }}>
          {Spid}
          {Cie}
          {SelfID}
        </div>
      </div>
    );

    return (
      <div>
        {Title}
        {Body}
      </div>
    );
  },
);
